/**
 * Global constants shared across the app and Tailwind config.
 *
 * Note: This file must remain a `.js` file (not `.ts`) so it can be
 * imported in `tailwind.config.js`, which does not support TypeScript.
 */

export const brandColors = {
  black: '#01030b',
  darkSilver: '#737b8a',
  mediumSilver: '#dfe0e3',
  silver: '#f5f7fa',
  lightSilver: '#f0f0f2',
  darkestBlue: '#002a94',
  darkerBlue: '#0039c9',
  darkBlue: '#0048ff',
  blue: '#316bff',
  lightBlue: '#5082ff',
  lighterBlue: '#86a8ff',
  lightestBlue: '#bccfff',
  green: '#2ed8a7',
  red: '#ef4444',
  yellow: '#ffc531',
};
